
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxFilterRow,
    DxSearchPanel,
    DxScrolling,
    DxPager,
    DxValidationRule
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxToast } from 'devextreme-vue/toast';


import HabilidadService from '../services/habilidad-service';
import GuiaEvaluacionCapituloService from '../services/guiaevaluacioncapitulo-service';




export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxEditing,
        DxLookup,
        DxForm,
        DxItem,
        DxFilterRow,
        DxSearchPanel,
        DxScrolling,
        DxPager,
        DxToast,
        DxValidationRule
    },
    props: {
        supplierId: {
            type: Number,
            default: null,
        },
    },
    data() {

        return {

            procedimientos: null,
            dataSourceUsuarios: null,
            dataSourcePadre: null,

            allowedPageSizes: [5, 10, 20, 50, 'all'],
            showInfo: true,
            showNavButtons: true,
            isVisible: false,
            message: '',
            type: 'info',
            popupOptions: {
                title: 'Capitulos - Habilidad',
                showTitle: true,
                width: 400,
                height: 350,
            },



        };
    },
    created() {

        this.GuiaEvaluacionCapituloService = new GuiaEvaluacionCapituloService();
        this.HabilidadService = new HabilidadService();

    },
    mounted() {

        this.loadDataInfo();
    },
    methods: {
        loadDataInfo() {


            //this.usuarioService.getUsuario().then(data => this.dataSourceUsuarios = data);
            let id = this.supplierId;


            this.HabilidadService.getHabilidad().then(data => this.dataSourcePadre = data);

            let myJSON = JSON.stringify({
                pguiaevaluacionid: id,

            });

            this.GuiaEvaluacionCapituloService.getGuiaEvaluacionCapitulo(myJSON).then(data => this.dataSourceUsuarios = data);

        },
        onSaved() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        onEditCanceled() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        logEvent(eventName) {
            this.events.unshift(eventName);
        },

        deleteRegister(e) {

            let myJSON = JSON.stringify({
                pid: e.data.id,
            });


            this.GuiaEvaluacionCapituloService.deleteGuiaEvaluacionCapitulo(myJSON).then(() => {
                this.type = 'success';
                this.message = 'Se ha eliminado el registro';
                this.isVisible = true;
                this.loadDataInfo();
            });

        },
        editRegister(e) {

            let idguia = this.supplierId;
            let myJSON = JSON.stringify({
                pid: e.data.id,
                pguiaevaluacionid: idguia,
                phabilidadid: e.data.habilidadid,
                porden: e.data.orden,
            });


            this.GuiaEvaluacionCapituloService.updateGuiaEvaluacionCapitulo(myJSON).then(() => {
                this.type = 'success';
                this.message = 'Se ha actualizado el registro';
                this.isVisible = true;
                this.loadDataInfo();
            });

        },
        createRegister(e) {


            let idguia = this.supplierId;
            let myJSON = JSON.stringify({
                pguiaevaluacionid: idguia,
                phabilidadid: e.data.habilidadid,
                porden: e.data.orden,

            });


            this.GuiaEvaluacionCapituloService.createGuiaEvaluacionCapitulo(myJSON).then(() => {
                this.type = 'success';
                this.message = 'Se ha creado el registro';
                this.isVisible = true;
                this.loadDataInfo();
            });

        },
        onInitNewRow(e) {
            e.data.bactivo = true;
        },
    },
};
